import React from 'react';
import { Link } from 'react-router-dom';

export const IPE_BRAND_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/ipe/yc-logo.png`;

export function IpeBrandLogo({ size = 36, className = '', alt = 'IPE' }) {
  return (
    <img
      src={IPE_BRAND_LOGO_SRC}
      alt={alt}
      className={`ipe-brand-logo${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      draggable={false}
    />
  );
}

export function IpeBrandMark({
  showText = true,
  text = 'IPE',
  textClassName = '',
  logoSize = 36,
  className = '',
  to,
  href,
  onClick,
  ariaLabel = '返回首页',
}) {
  const content = (
    <>
      <IpeBrandLogo size={logoSize} />
      {showText && text ? <span className={textClassName}>{text}</span> : null}
    </>
  );

  const markClassName = `ipe-brand-mark${className ? ` ${className}` : ''}${to || href || onClick ? ' ipe-brand-mark--link' : ''}`;

  if (to) {
    return (
      <Link to={to} className={markClassName} aria-label={ariaLabel} onClick={onClick}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={markClassName} aria-label={ariaLabel} onClick={onClick}>
        {content}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" className={markClassName} aria-label={ariaLabel} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className={markClassName}>{content}</div>;
}
